export enum Steps {
  closed = 'closed',
  questions = 'questions',
  connect_bank = 'connect_bank',
  activation_success_msg = 'activation_success_msg',
  ops_manual_activation_msg = 'ops_manual_activation_msg',
  done = 'done',
}
